import { render } from "./About.vue?vue&type=template&id=ab87cb04&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=ab87cb04&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Carla\\Projects\\Personal\\my-personal-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab87cb04"]])

export default __exports__